import React from "react";
import Animation from "Components/Animation";

// Assets
import error from "Assets/Icons/error.svg";
import check from "Assets/Icons/check.svg";
import enrollfail from "Assets/Img/error.json";
//import withdraw from "Assets/Img/vip-withdraw.json";
import withdraw from "Assets/Icons/hourglass.svg";
import enrollsuccess from "Assets/Img/success.json";

import "./Icon.scss";

const IconTypeNames = {
  error: "error",
  check: "check",
  withdraw: "withdraw",
  enrollsuccess: "enrollsuccess",
  enrollfail: "enrollfail",
};

const Icon = ({ typeName }) => {
  let icon;

  switch (typeName?.toLowerCase()) {
    case IconTypeNames.error:
      icon = <img className="icon" alt="encircled exclamation point" src={error} />;
      break;
    case IconTypeNames.check:
      icon = <img className="icon" alt="encircled check mark" src={check} />;
      break;
    case IconTypeNames.withdraw:
      //icon = <Animation animationData={withdraw} width={250} height={250} />
      icon = <img alt="hourglass bottom" src={withdraw} width={120} height={120} />;
      break;
    case IconTypeNames.enrollsuccess:
      icon = <Animation animationData={enrollsuccess} width={152} height={152} isLoop={false} />;
      break;
    case IconTypeNames.enrollfail:
      icon = <Animation animationData={enrollfail} width={152} height={152} isLoop={false} />;
      break;
    default:
      icon = <img alt="icon missing" src="" />;
  }
  return <>{icon && icon}</>;
};

export { IconTypeNames }
export default Icon;